/**
 * The controls that sit at the right-hand end of the global top bar.
 *
 * A page declares its path with `useBreadcrumb` and its controls with
 * `useBreadcrumbActions`, and both render in the one bar the app already has —
 * so the path sits in the same place, at the same size, on every page. A page
 * that builds its own header row instead ends up a few pixels taller and a
 * point larger than the rest of the app, which is exactly how the alerts pages
 * drifted.
 *
 * The bar is h-8 with 4px of top padding, so its content box is 28px and a
 * control in it is h-7 — an h-8 button in a 28px box has its bottom border
 * shaved off, which is what these looked like. Three of them: secondary (the
 * default), primary (the one commit action on the page), and danger.
 */

const BASE = 'inline-flex h-7 items-center gap-1.5 rounded-md px-2.5 text-[12px] transition-colors disabled:opacity-40';

/** Bordered and quiet — the default for anything that is not the main action. */
export const ACTION_BTN =
  `${BASE} border border-[color:var(--border-default)] bg-surface text-[color:var(--text-primary)] hover:bg-surface-hover`;

/** Filled. One per page at most: Save, Create, the thing the page is for. */
export const ACTION_BTN_PRIMARY =
  `${BASE} bg-brand font-medium text-ink-onBrand hover:bg-brand-hover`;

/** Bordered, and the border carries the warning rather than a filled red slab. */
export const ACTION_BTN_DANGER =
  `${BASE} border border-[color:var(--feedback-error)] bg-surface text-danger hover:bg-danger-soft`;
